<label>
    <span class="taxonomy-select-label sir-text-style-paragraph-m-bold">
        {{ label() }}
        <span class="taxonomy-select-optional sir-text-style-system-s-default">({{ optionalSuffix() }})</span>
    </span>

    <span class="taxonomy-select-field">
        <select
            class="taxonomy-select-control sir-text-style-paragraph-m-default"
            [value]="value() ?? ''"
            (change)="onChange($event)">
            <option value="">{{ noSelectionLabel() }}</option>

            @for (option of options(); track option.token) {
                <option [value]="option.token" [selected]="option.token === value()">{{ option.label }}</option>
            }
        </select>
        <sirius-icon class="taxonomy-select-caret" name="caret_down" aria-hidden="true" />
    </span>
</label>
